import classNames from 'classnames'
import React from 'react'
import { Link } from 'react-router-dom'

import type { ButtonProps } from './Button.props'

export function Button({ variant = 'accent', href, target, type = 'button', onClick, className, disabled, children, fulFill, rootRef, ...props }: ButtonProps) {
  // const navigate = useNavigate()

  // const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
  //   if (href) {
  //     target ? window.open(href, '_blank')?.focus() : navigate(href)
  //   } else {
  //     onClick && onClick(e)
  //   }
  // }

  if (href)
    return (
      <Link
        ref={rootRef}
        className={classNames('btn', className, {
          'btn--accent': variant === 'accent',
          'btn--grey': variant === 'gray',
          'btn--trans': variant === 'border',
          fulfill: fulFill,
        })}
        to={href}
        target={target}
        rel="noopener noreferrer"
      >
        {children}
      </Link>
    )

  return (
    <button
      ref={rootRef}
      type={type}
      className={classNames('btn', className, {
        'btn--accent': variant === 'accent',
        'btn--grey': variant === 'gray',
        'btn--trans': variant === 'border',
        fulfill: fulFill,
      })}
      disabled={variant === 'gray' || disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  )
}
